import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

type SetSaveJobAdParams = {
  jobAdId: string
  isJobAdSaved: boolean
  jobAdLocale: string
  hostname: string
}
type JobAdRemoveFromCartResult = {
  _valid: boolean
  errors: unknown
  executed: boolean
  job_offer: unknown
  metadata: unknown
  my_job_offer: {
    id: number
    job_offer_id: number
    user_id: number
    created_at: string
    updated_at: string
    status: string
  }
  result: unknown
  validation_context: unknown
}

type AddToCartResult = {
  _valid: boolean
  errors: unknown
  executed: boolean
  job_offer: unknown
  metadata: unknown
  result: unknown
  user: unknown
  validation_context: unknown
}

export const toggleJobAdSavedStatus = ({
  jobAdId,
  isJobAdSaved,
  jobAdLocale,
  hostname,
}: SetSaveJobAdParams): Promise<JobAdRemoveFromCartResult | AddToCartResult> => {
  const path = `/${jobAdLocale}/job-offers/${jobAdId}/${isJobAdSaved ? "add_to_cart" : "remove_from_cart"}`
  return fetcher(path, {
    hostname,
    requestInit: {
      headers: {
        "Accept-Language": jobAdLocale,
      },
    },
    serviceDomain: "MONOLITH_API",
  })
    .then(
      getResultFromResponse<JobAdRemoveFromCartResult | AddToCartResult>({
        transformResult: toCamelCaseKeys<JobAdRemoveFromCartResult | AddToCartResult>,
      })
    )
    .catch(handleFetchError(path, { isJobAdSaved, jobAdId }))
}
